export default {"src":"/_next/static/media/no-products.73b22c24.svg","height":320,"width":514,"blurWidth":0,"blurHeight":0};